<template>
  <center>
    <h1 class="tw-font-bold tw-text-light-green ">404</h1>
    <h2 >Sorry, Page not found</h2>
      <a href="/">
        <v-btn  class="tw-mt-10" outlined>Go back to Home</v-btn>
      </a>
  </center>
</template>

<script>
export default {
  name: "NotFound",
};
</script>

<style scoped>
center {
  margin: 15vw;
}

h1 {
  font-size: 7rem;
}

h2 {
  font-size: 1.5rem;
}


</style>
